import { TOKEN } from '../contexts/authContext';
import { LOCALHOST, SIGNIN } from '../routes/paths';

/** Multipart: si no se detecta bien, el body se manda como JSON y el archivo se pierde. */
const isFormDataPayload = (data: unknown): boolean => {
    if (typeof FormData === 'undefined' || data == null || typeof data !== 'object') {
        return false;
    }
    if (data instanceof FormData) {
        return true;
    }
    return (
        typeof (data as FormData).append === 'function' &&
        typeof (data as FormData).get === 'function'
    );
};

export class ApiService {
    private readonly baseUrl?: string;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl || LOCALHOST;
    }

    async get<T>(path: string, params?: Record<string, any>): Promise<T> {
        return this.request<T>('GET', path, undefined, params);
    }

    async post<T>(
        path: string,
        data: any,
        params?: Record<string, any>,
        headers?: HeadersInit | undefined
    ): Promise<T> {
        return this.request<T>('POST', path, data, params, headers);
    }

    async put<T>(path: string, data?: any): Promise<T> {
        return this.request<T>('PUT', path, data);
    }

    async delete(path: string, data?: any): Promise<void> {
        return this.request<void>('DELETE', path, data);
    }

    private async request<T>(
        method: string,
        path: string,
        data?: any,
        params?: Record<string, any>,
        headers?: HeadersInit | undefined
    ): Promise<T> {
        let url = `${this.baseUrl}${path}`;

        if (params) {
            const urlFormater = new URL(url);
            Object.entries(params).forEach(([key, value]) => {
                urlFormater.searchParams.append(key, value);
            });
            url = urlFormater.toString();
        }

        const isFormData = isFormDataPayload(data);

        const defaultJsonHeaders = {
            accept: '*/*',
            Authorization: `Bearer ${sessionStorage.getItem(TOKEN)}`,
            'Content-Type': 'application/json',
        };

        let requestHeaders: HeadersInit;
        if (isFormData) {
            const merged: Record<string, string> = {
                accept: '*/*',
                Authorization: `Bearer ${sessionStorage.getItem(TOKEN)}`,
                ...(headers && typeof headers === 'object' && !Array.isArray(headers)
                    ? (headers as Record<string, string>)
                    : {}),
            };
            delete merged['Content-Type'];
            requestHeaders = merged;
        } else {
            requestHeaders = headers || defaultJsonHeaders;
        }

        const response = await fetch(url, {
            method,
            headers: requestHeaders,
            body: isFormData ? data : JSON.stringify(data),
        });

        if (!response.ok) {
            if (
                response.status === 401 &&
                window.location.pathname !== SIGNIN
            ) {
                // Redirect to login page
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = SIGNIN;
            } else {
                console.error(
                    `Failed to ${method.toLowerCase()} data at ${url}`
                );
            }
        }

        return response.json() as Promise<T>;
    }
}

export const apiService = new ApiService();
export const apiServicecrmware = new ApiService(
    process.env.REACT_APP_URL_CRMWARE
);
